import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class RangeSlider extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      value: 0,
      isMounted: false,
    };
    this.division = 0;
    this.width = 0;
  }

  componentDidMount() {
    this.division = this.width / (this.props.max - this.props.min - 1);
    setTimeout(
      () =>
        this.setState({
          isMounted: true,
          value: this.props.startPosition,
        }),
      0,
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.startPosition !== this.props.startPosition) {
      this.setState({
        value: nextProps.startPosition,
      });
    }
  }

  handleHitboxClick(index) {
    this.setState({
      value: index,
    });
    this.props.onChange(index);
  }

  render() {
    let handleSize = 20;
    let styles = {
      rangeSlider: {
        position: 'relative',
        padding: handleSize * 1.5,
        paddingTop: 30,
        paddingBottom: 10,
      },
      rangeSlider__slider: {
        display: 'inline-block',
        position: 'relative',
        height: 6,
        border: '3px solid lightgrey',
        borderRadius: 10,
        width: '100%',
        // background: "#212121"
      },
      rangeSlider__handle: {
        position: 'absolute',
        borderRadius: '50%',
        // width: handleSize,
        // height: handleSize,
        width: 12,
        height: 12,
        background: '#91a2b9',
        left: -handleSize * 0.5,
        top: 2.5,
        transform: `translate3d(
                            ${this.state.value *
                              this.props.step *
                              this.division}px, 
                            ${-handleSize * 0.5 + 1}px, 0px)`,
        transition: 'transform 200ms',
        cursor: 'pointer',
      },
      rangeSlider__hitbox: {
        display: 'inline-block',
        position: 'absolute',
        width: this.division,
        // - (this.division / this.props.max)
        // + (handleSize / this.props.max),
        height: 20,
        transform: `translateY(${-handleSize * 0.5 + 1}px)`,
        cursor: 'pointer',
      },
      rangeSlider__label: {
        position: 'absolute',
        width: this.division,
        fontSize: 10,
        cursor: 'pointer',
      },
    };
    return (
      <div style={styles.rangeSlider}>
        <div
          style={styles.rangeSlider__slider}
          ref={el => (el != null ? (this.width = el.clientWidth) : null)}
        >
          {Array.apply(null, Array(this.props.max)).map((_, i) => (
            <div key={i}>
              <div
                style={Object.assign({}, styles.rangeSlider__hitbox, {
                  left:
                    (this.division -
                      this.division / this.props.max +
                      handleSize / this.props.max) *
                      i -
                    handleSize * 0.5,
                })}
                onClick={() => this.handleHitboxClick(i)}
              />
              <div
                style={Object.assign({}, styles.rangeSlider__label, {
                  transform: `translate3d(
                                        ${i * this.division -
                                          this.division * 0.5 -
                                          3}px,
                                        ${-handleSize * 1.5}px, 0px)`,
                })}
                onClick={() => this.handleHitboxClick(i)}
              >
                {this.props.labels[i]}
              </div>
            </div>
          ))}
          <div style={styles.rangeSlider__handle} />
        </div>
      </div>
    );
  }
}

export default connect(
  null,
  null,
  null,
  { forwardRef: true },
)(RangeSlider);
